import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Select } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';
import { FieldGroup } from '../../../models';

export function EditFieldGroupPage(props: {
  gridId?: string;
  fieldGroups?: FieldGroup[];
  scheme?: any[];
  level?: string[];
  fieldGroup?: FieldGroup;
  onSaved: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [parentOptions, setParentOptions] = useState<any[]>();
  const [hexCodeBackground, setHexCodeBackground] = useState(props.fieldGroup?.hexCodeBackground);
  const [hexCodeTitle, setHexCodeTitle] = useState(props.fieldGroup?.hexCodeTitle);

  const initialFormValues = {
    name: props.fieldGroup?.name || undefined,
    description: props.fieldGroup?.description || undefined,
    hexCodeBackground: props.fieldGroup?.hexCodeBackground || undefined,
    hexCodeTitle: props.fieldGroup?.hexCodeTitle || undefined,
    hideOnNewRecord: props.fieldGroup?.hideOnNewRecord || undefined,
    level: props.level?.join('###'),
  };

  useEffect(() => {
    if (!props.scheme?.length || !props.fieldGroups?.length) {
      setParentOptions(undefined);
      return;
    }

    const addGroup = (schemeItem: any, valuePrefix: string, labelPrefix: string, options: any[]) => {
      const group = props.fieldGroups?.find(g => g.id === schemeItem.id);
      if (!group) {
        return;
      }
      const value = (valuePrefix + (valuePrefix ? '###' : '') + group.id).trim();
      const label = (labelPrefix + (labelPrefix ? ' > ' : '') + group.name).trim();
      const option: any = { value, label };
      options.push(option);

      if (schemeItem.children?.length) {
        for (const item of schemeItem.children) {
          if (item.itemType === 'fieldGroup') {
            addGroup(item, value, label, newOptions);
          }
        }
      }
    };

    const newOptions: any[] = [];
    for (const item of props.scheme) {
      if (item.itemType === 'fieldGroup') {
        addGroup(item, '', '', newOptions);
      }
    }

    setParentOptions(newOptions);
  }, [props.fieldGroups, props.scheme]);

  const onHexCodeBackgroundChange = (e: any) => {
    const value = e.target?.value;
    setHexCodeBackground(value);
  };

  const onHexCodeTitleChange = (e: any) => {
    const value = e.target?.value;
    setHexCodeTitle(value);
  };

  const onFinish = (values: any) => {
    setLoading(true);

    let action;
    const body = {
      ...values,
    };

    body.gridId = props.gridId;
    if (body.level) {
      body.level = body.level.split('###');
    }

    if (props.fieldGroup) {
      action = apiClient.put(`field-groups/${props.fieldGroup?.id}`, body);
    } else {
      action = apiClient.post('field-groups', body);
    }

    action
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Form labelCol={{ span: 7 }} wrapperCol={{ span: 17 }} initialValues={initialFormValues} onFinish={onFinish}>
        <Form.Item label="Üst grup" name="level">
          <Select>
            {parentOptions?.map(o => (
              <Select.Option value={o.value} key={o.value}>
                {o.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="İsim"
          name="name"
          rules={[
            { required: true, message: 'Zorunlu alan' },
            { max: 100, message: 'En fazla 100 karakter' },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Açıklama"
          name="description"
          rules={[
            { required: true, message: 'Zorunlu alan' },
            { max: 400, message: 'En fazla 400 karakter' },
          ]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Arka plan (HEX)" name="hexCodeBackground" rules={[{ max: 9, message: 'En fazla 9 karakter' }]}>
          <div style={{ display: 'flex' }}>
            <Input onChange={onHexCodeBackgroundChange} />
            <div
              style={{
                width: '100px',
                height: '32px',
                marginLeft: '1rem',
                border: '1px solid #dedede',
                backgroundColor: hexCodeBackground,
              }}
            />
          </div>
        </Form.Item>

        <Form.Item label="Başlık (HEX)" name="hexCodeTitle" rules={[{ max: 9, message: 'En fazla 9 karakter' }]}>
          <div style={{ display: 'flex' }}>
            <Input onChange={onHexCodeTitleChange} />
            <div
              style={{
                width: '100px',
                height: '32px',
                marginLeft: '1rem',
                border: '1px solid #dedede',
                backgroundColor: hexCodeTitle,
              }}
            />
          </div>
        </Form.Item>

        <Form.Item label="Yeni kayıt ekranında gösterme" name="hideOnNewRecord" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {props.fieldGroup ? 'Kaydet' : 'Ekle'}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
